import { useSelector } from 'react-redux';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as creditAppSelectors from '@makemydeal/dr-dash-store/selectors/creditAppSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { CASH } from '@makemydeal/dr-platform-types';

export type PushToRouteOneCta = {
    /** Whether the "Push to RouteOne" CTA should be rendered. */
    showCta: boolean;
    /** Whether the generic push-to-FI path is active, so a call site cannot render the generic dialog off the legacy gate. */
    isGenericPath: boolean;
};

/**
 * Single source of truth for the "Push to RouteOne" CTA gate, shared by both call sites.
 */
export const usePushToRouteOneCta = (): PushToRouteOneCta => {
    const enablePushToR1 = useSelector(featureToggleSelectors.enablePushToR1);
    const creditProvider = useSelector(dealerSelectors.getCreditProvider);
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const enablePushToR1CTA = enablePushToR1 && creditProvider !== 'dealertrack' && offerType !== CASH;

    const isGenericPath = useSelector(featureToggleSelectors.isGenericPushToFiForR1JEnabled);
    const creditAppCompleted = useSelector(creditAppSelectors.isCreditAppCompleted);
    const isFlexBuyPayment = useSelector(offerReduxSelectors.isFlexBuyPayment);
    const isBusinessShopper = useSelector(offerSelectors.getIsBusinessShopper);
    const isMvLiteEnabled = useSelector(dealerSelectors.isMvLiteEnabled);

    const showCta = isGenericPath
        ? enablePushToR1CTA && !isFlexBuyPayment && !isBusinessShopper && !isMvLiteEnabled
        : enablePushToR1CTA && creditAppCompleted && !isMvLiteEnabled;

    return { showCta, isGenericPath };
};
